import React from 'react';
import styled from 'styled-components';


const FAQPage = () => {
  
  const Wrapper = styled.div`
  margin: 3rem;
    div {
      display: grid;
      margin-left: 3rem;
      margin-right: 3rem;
    }
    .answer {
      text-align: justify;
      max-height: 0;
      overflow: hidden;
      border: 0px solid;
      border-radius: 1rem;
      border-color: grey;
      padding-left: 3rem;
      padding-right: 3rem;
      transition: max-height 0.5s ease-in, padding 0.5s ease-in;
    }
    .question {
      /* width: 100%;
      display: flex;
      justify-content: space-evenly;
      border: black;
      padding: 0;
      margin: 0; */
      display: grid;
      grid-template-columns: 1fr 1fr;
      border: 1px solid;
      border-radius: 1rem;
      border-color: grey;
      padding: 2rem;
      text-align: start;
    }

    div > div:hover > .answer {
      padding: 3rem;
      border: 1px solid;
      border-color: grey;
      transition: max-height 0.5s ease-in, padding 0.5s ease-in;
      max-height: 300px;
    } 

    div > div:hover img {
      transform: rotate(540deg);
      transition: transform 0.7s ease-in-out;
    } 

    .question > img {
      transition: transform 0.7s ease-in-out;
      justify-self: end;
    }

    h1 {
      text-align: start;
      color: #010198;
      margin: 3rem;

    }


    /* Extra small devices (phones, less than 576px) */
    @media only screen and (max-width: 575.98px) {  }

    /* Small devices (landscape phones, 576px and up) */
    @media only screen and (min-width: 576px) {  }

    /* Medium devices (tablets, 768px and up) */
    @media only screen and (min-width: 768px) {  }

    /* Large devices (desktops, 992px and up) */
    @media only screen and (min-width: 992px) {  }

    /* Extra large devices (large desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {  }

  `
  

  return (
    <Wrapper>
      <h1>FAQ</h1>
      <div>
        <div>
          <p className="question">What is jobbwrk?<img className="down" src="down.svg" alt="" /></p>
          <p className="answer">Jobbwrk is a dynamic online platform that facilitates direct connections between professionals and businesses. With options like "Find Project" for job searchers and "Post Project" for hiring organisations, it makes collaboration easy.</p>
        </div>

        <div>
          <p className="question">How can I register with Jobbwrk?<img className="down" src="down.svg" alt="" /></p>
          <p className="answer">It's simple to sign up with Jobbwrk. Select whether you are a job poster or a job seeker by clicking the "Sign Up" button, then proceed with the straightforward registration process.</p>
        </div>

        <div>
          <p className="question">What advantages does the "Post Project" tool provide to companies?<img className="down" src="down.svg" alt="" /></p>
          <p className="answer">"Post Project" offers companies the opportunity to showcase a comprehensive company profile and attract top personnel. It simplifies communication of project specifics, including requirements and scope, and enhances the effectiveness of response management.</p>
        </div>

        <div>
          <p className="question">Is it free to use Jobbwrk?<img className="down" src="down.svg" alt="" /></p>
          <p className="answer">Yes, you are always free to change and update the information on your profile. Just sign in, navigate to your profile, and make the required adjustments.</p>
        </div>

        <div>
          <p className="question">Can I change the information in my profile after registering?<img className="down" src="down.svg" alt="" /></p>
          <p className="answer">It's simple to sign up with Jobbwrk. Select whether you are a job poster or a job seeker by clicking the "Sign Up" button, then proceed with the straightforward registration process.</p>
        </div>

        <div>
          <p className="question">What support options are available if I encounter issues?<img className="down" src="down.svg" alt="" /></p>
          <p className="answer">Jobbwrk provides user support through our Help Center, where you can find answers to common questions. Additionally, you can contact our support team for assistance.</p>
        </div>

        

        
        
      </div>
      {/* {faqs.map((faq, i) => (
        <FAQ key={i} {faq} />
      ))} */}
    </Wrapper>
  );
};

export default FAQPage;

